// dmarc-frontend/src/services/api.js
import axios from "axios";
import { getToken, logout } from "../utils/auth";

// Base URL de la API DMARC:
// - En producción: usamos REACT_APP_API_BASE = "/api/dmarc"
// - En desarrollo local: si no está definida, fallback a "/api/dmarc"
const API_BASE = process.env.REACT_APP_API_BASE || "/dmarc";

console.log("[DMARC FRONT] API_BASE =", API_BASE);

const api = axios.create({
  baseURL: API_BASE,
  // opcional: timeout
});


api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Detecta expiración de sesión (401 Unauthorized)
    if (error?.response?.status === 401) {
      // Dispara un evento global para que la UI muestre el modal de sesión expirada
      window.dispatchEvent(new Event('session-expired'));
    }
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 403) {
      window.dispatchEvent(new Event('unauthorized-domain'));
    }
    return Promise.reject(error);
  }
);

export { api };
